<template>
  <div class="page-loader">
    <ui-progress-circular :show="true"
                          type="indeterminate"
                          :size="40">
    </ui-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'page-loader'
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .page-loader {
    position: relative;
    height: 75px;

    .ui-progress-circular {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -16px;
      margin-top: -16px;
    }
  }
</style>



// WEBPACK FOOTER //
// PageLoader.vue?940458aa